import { useEffect } from 'react';

const BookingWidget = ({ slug }) => {

    useEffect(() => {
        if (!slug) return;

        if (document.getElementById("logout-widget-script")) {
            initWidget();
            return;
        }

        const script = document.createElement("script");
        script.src = "https://logout.world/static/widget/logout-booking.js";
        script.id = "logout-widget-script";
        script.async = true;

        script.onload = () => {
            initWidget();
        };

        document.body.appendChild(script);

        function initWidget() {
            if (!window.logout?.widget) return;

            window.logout.widget.setConfig({
                eventSlug: slug,
                placement: "#book-container",
                customClass: "btn-custom",
                btnId: "logout-bnb",
                downloadBtnId: "logout-download-button",
                enquiryBtnId: "logout-enquiry-button",
                showEverything: true,
                onlyButton: false,
                showItineraryButton: true,
                showEnquiryButton: true,
                bookNowButtonColor: "#005942",
                itineraryButtonColor: "#000000",
                booknowButtonName: "Book Now",
                itineraryButtonName: "Itinerary",
            });

            window.logout.widget.init();
        }
    }, [slug]);

    return <div id="book-container"></div>
}

export default BookingWidget;